import { render, staticRenderFns } from "./ConfigViewDialogV2.vue?vue&type=template&id=22a12a9d&scoped=true"
import script from "./ConfigViewDialogV2.vue?vue&type=script&lang=js"
export * from "./ConfigViewDialogV2.vue?vue&type=script&lang=js"
import style0 from "./ConfigViewDialogV2.vue?vue&type=style&index=0&id=22a12a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a12a9d",
  null
  
)

export default component.exports